module.exports = __webpack_public_path__ + "static/img/kd100_visitor_desc.e21495e2.png";